import React, { Component } from 'react';
import Typography from '@material-ui/core/Typography';
import { userService } from '../services/user.service';

export class Home extends Component {
    static displayName = Home.name;

    render() {
       var user = userService.getUser();
        return (
            <div>
                <Typography variant="h5" component="h3">
                    Vitajte {user.fullName}!
                </Typography>
                <Typography variant="body2" gutterBottom>
                    ...
                </Typography>
            </div >
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Home.js